import { STORE_PREFIX } from './constants.js';
import admin_store from '@/stores_new/admin/index.js';

export default {
  created() {
    this.$store.registerModule(STORE_PREFIX + 'admin', admin_store);
  },
  destroyed() {
    this.$store.unregisterModule(STORE_PREFIX + 'admin');
  }
}